import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';
import { useComparisonSkus } from 'components/Catalog/ProductGrid/hooks/useComparisonSkus';

const OverviewZone = ({ comparisonData = {}, getText = () => {} }) => {
    const skus = useComparisonSkus(comparisonData);

    const renderContent = () => {
        return (
            <Text
                fontSize='sm'
                color='gray'
            >
                Overview Zone
            </Text>
        );
    };

    return (
        <CompareZoneBase
            selectedProducts={skus}
            getText={getText}
            titleKey='overview'
            renderContent={renderContent}
        />
    );
};

OverviewZone.propTypes = {
    comparisonData: PropTypes.object,
    getText: PropTypes.func
};

export default wrapFunctionalComponent(OverviewZone, 'OverviewZone');
